<template>
  <ss-modal
    v-if="isModalVisible"
    title="Podsumowanie kwoty"
    intro="bounceIn"
    outro="bounceOut"
    class="cost-breakdown">
    <!-- HEADER -->
    <div slot="modal-header">
      <template v-if="viewType === 'details_to_finish_credit_under_contract'">
        Podsumowanie kwoty do spłaty
      </template>
      <template v-else>
        Podsumowanie kwoty do spłaty na dzień dzisiejszy
      </template>
      <i class="close" @click="closeModal(false)"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body">
      <template v-if="loadError">
        <d-alert
          show
          theme="warning">
          Wczytywanie danych nie powiodło się.
          <a
              href="javascript:window.location.reload();"
              class="alert-link">
              Odśwież stronę
          </a>
          aby spróbować ponownie.
        </d-alert>
      </template>
      <div v-else-if="!loaded || !dataToDisplay" style="min-height: 80px;">
        <h2 class="preloader isLoading mt-4">Trwa ładowanie</h2>
      </div>
      <div v-else>
        <p class="h6 mb-4">
          {{ viewLoanSumTitle }}: <strong class="text-primary">{{ toNumber(viewLoanSum) }} zł</strong>
        </p>

        <table class="table mb-0 border-top-0 responsive-table">
          <thead>
            <tr>
              <th scope="col" class="border-0">Składowa</th>
              <th scope="col" class="border-0">Netto</th>
              <th scope="col" class="border-0">Brutto</th>
              <th scope="col" class="border-0">VAT</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in costElementsInOrder"
              :key="`cost-element-` + index">
              <td>
                <dt>Składowa</dt>
                <dd>
                  {{ item.label }}
                  <div v-if="item && item.subTable && item.subTable.length > 0">
                   <tr v-for="(subItem, subIndex) in item.subTable" :key="`sub-item-` + subIndex">
                      <span class="text-muted ml-3">{{ subItem.label }}</span>
                    </tr>
                  </div>
                </dd>
              </td>
              <td>
                <dt>Netto</dt>
                <dd>
                  {{ toNumber(dataToDisplay.netto[item.field]) }} zł
                  <div v-if="item && item.subTable && item.subTable.length > 0">
                    <tr v-for="(subItem, subIndex) in item.subTable" :key="`sub-item-` + subIndex">
                      <span class="text-muted">{{ toNumber(dataToDisplay.netto[subItem.field]) }} zł</span>
                    </tr>
                  </div>
                </dd>
              </td>
              <td>
                <dt>Brutto</dt>
                <dd>
                  {{ toNumber(dataToDisplay.brutto[item.field]) }} zł
                    <div v-if="item && item.subTable && item.subTable.length > 0">
                    <tr v-for="(subItem, subIndex) in item.subTable" :key="`sub-item-` + subIndex">
                      <span class="text-muted">{{ toNumber(dataToDisplay.brutto[subItem.field]) }} zł</span>
                    </tr>
                  </div>
                </dd>
              </td>
              <td>
                <dt>VAT</dt>
                <dd>
                  {{ toNumber(dataToDisplay.vat[item.field]) }} zł
                  <div v-if="item && item.subTable && item.subTable.length > 0">
                    <tr v-for="(subItem, subIndex) in item.subTable" :key="`sub-item-` + subIndex">
                      <span class="text-muted">{{ toNumber(dataToDisplay.vat[subItem.field]) }} zł</span>
                    </tr>
                  </div>
                </dd>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td><strong>Suma</strong></td>
              <td><strong>{{ toNumber(dataToDisplay.netto.sum) }} zł</strong></td>
              <td><strong>{{ toNumber(dataToDisplay.brutto.sum) }} zł</strong></td>
              <td><strong>{{ toNumber(dataToDisplay.vat.sum) }} zł</strong></td>
            </tr>
            <tr
              v-if="shouldShowPaidSum"
              class="text-success">
              <td><strong>Wpłacono</strong></td>
              <td><strong>{{ toNumber(dataToDisplay.netto.paid_sum) }} zł</strong></td>
              <td><strong>{{ toNumber(dataToDisplay.brutto.paid_sum) }} zł</strong></td>
              <td><strong>{{ toNumber(dataToDisplay.vat.paid_sum) }} zł</strong></td>
            </tr>
          </tfoot>
        </table>
      </div>

    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal(false)"
        :class="{ disabled : actionInProgress }"
        theme="secondary">
        Zamknij
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import SsModal from '@/components/common/SsModal';

export default {
  name: 'ContractLoanCostBreakdownModal',
  components: {
    SsModal
  },
  props: {
    schedule: {
      required: false,
      type: Object,
      default: () => ({})
    },
    scheduleId: {
      required: true,
      type: Number
    }
  },
  computed: {
    dataToDisplay () {
      if (!this.isModalVisible) {
        return null;
      }

      console.log(this.data[this.viewType]);

      return this.data[this.viewType];
    },
    isVindication () {
      return this.schedule && this.schedule.contract_end_date_has_passed;
    },
    terminatedInterestLabel () {
      return this.isVindication ? 'Odsetki max. za opóźnienie po zakończeniu umowy' : 'Odsetki max. za opóźnienie po wypowiedzeniu';
    },
    costElementsInOrder () {
      return [{
        field: 'full_loan_amount',
        label: 'Kwota pożyczki (w tym prowizja)',
        subTable:[
          {
            field: 'loan_amount',
            label: 'Kapitał'
          }, {
            field: 'installment_sum',
            label: 'Prowizja'
          }
        ]
      },{
        field: 'interest',
        label: 'Odsetki umowne'
      }, {
        field: 'interest_penalty',
        label: 'Odsetki max. za opóźnienie'
      }, {
        field: 'vindication_fee',
        label: 'Opłata windykacyjna'
      }, {
        field: 'reminders_cost',
        label: 'Monity'
      }, {
        field: 'contract_penalties',
        label: 'Kary umowne'
      }, {
        field: 'contacts_cost',
        label: 'Opłaty inne'
      }, {
        field: 'interest_terminated',
        label: 'Odsetki umowne po wypowiedzeniu'
      }, {
        field: 'interest_after_close',
        label: 'Odsetki umowne po zakończeniu umowy'
      }, {
        field: 'terminated_interest',
        label: this.terminatedInterestLabel
      }];
    }
  },
  data () {
    return {
      actionInProgress: false,
      data: {
        details_to_finish_credit: {},
        details_to_finish_credit_under_contract: {}
      },
      isModalVisible: false,
      loaded: false,
      loadError: false,
      shouldShowPaidSum: true,
      viewLoanSum: 0,
      viewLoanSumTitle: 'Do spłaty',
      viewType: 'details_to_finish_credit_under_contract' // details_to_finish_credit_under_contract|details_to_finish_credit
    }
  },
  methods: {
    showModal (
      viewType = 'details_to_finish_credit_under_contract',
      viewLoanSum = 0,
      viewLoanSumTitle = 'Do spłaty',
      shouldShowPaidSum = true
    ) {
      Vue.set(this, 'viewType', viewType);
      Vue.set(this, 'viewLoanSum', viewLoanSum);
      Vue.set(this, 'viewLoanSumTitle', viewLoanSumTitle);
      Vue.set(this, 'shouldShowPaidSum', shouldShowPaidSum);

      if (!this.loaded || this.loadError) {
        this.fetchData();
      }

      this.$nextTick(() => {
        this.isModalVisible = true;
      })
    },
    closeModal () {
      this.isModalVisible = false;
    },
    fetchData () {
      Vue.set(this, 'loaded', false);

      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/schedules/get-schedule-amount-details',
        method: 'post',
        outputKey: 'data',
        loadedKey: 'loaded',
        errorKey: 'loadError',
        noPagination: true,
        params: {
          id: this.scheduleId
        }
      });
    },
    toNumber(number) {
      return Vue.toNumber(number);
    }
  }
}
</script>

<style>
.cost-breakdown .modal-body {
  margin-top: 0;
  margin-bottom: 0;
}
</style>
